<div class="section-data-presentation">
    <div class="data-col">
        <div *ngFor="let field of presentationData" class="data-box" [ngClass]="{'data-box--full-width' : field.fullWidth}">
            <label class="data-box__label">
                {{field.key}}
            </label>
            <label class="data-box__value">
                {{field.value}}
            </label>
        </div>
    </div>
    <div class="edit-col__edit-button">
        <div (click)="changeEditMode()" class="container--edit-button">
            <img class="edit-col__edit-button__edit-icon" *ngIf="isNext" [src]="editIcon" alt="">
            <label>{{editButtonLabel| translate}} </label>
            <mat-icon *ngIf="!isNext">arrow_right</mat-icon>
        </div>
    </div>
</div>

